/**
 * BrandsWhyExperts.tsx — Gold Garage Door / Brands · Section 4/8
 * Cream · "Why brand expertise matters" · 4 reason cards + by-the-numbers fact row.
 * MOBILE: real <style> media queries.
 * 10WEB AI: keep inline SVG + <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";

/** box — DO NOT REPLACE WITH IMG */
const IconBox = () => <svg data-icon-container="lucide-do-not-replace" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={GOLD_DARK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="m3.3 7 8.7 5 8.7-5" /><path d="M12 22V12" /></svg>;
/** wrench — DO NOT REPLACE WITH IMG */
const IconWrench = () => <svg data-icon-container="lucide-do-not-replace" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={GOLD_DARK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></svg>;
/** zap — DO NOT REPLACE WITH IMG */
const IconZap = () => <svg data-icon-container="lucide-do-not-replace" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={GOLD_DARK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" /></svg>;
/** shield — DO NOT REPLACE WITH IMG */
const IconShield = () => <svg data-icon-container="lucide-do-not-replace" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={GOLD_DARK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" /><path d="m9 12 2 2 4-4" /></svg>;
const REASONS = [{
  icon: <IconBox />,
  title: "Genuine parts on the van",
  body: "We stock the right springs, gears, remotes and boards for each brand — so most jobs are fixed first visit, not after a parts wait."
}, {
  icon: <IconWrench />,
  title: "Brand-specific know-how",
  body: "Every brand has its quirks. Knowing them means faster diagnosis, cleaner repairs, and no guesswork on your dime."
}, {
  icon: <IconZap />,
  title: "Correct recalibration",
  body: "Travel limits, force settings and safety beams differ per system. We set them to spec so your door is safe and quiet."
}, {
  icon: <IconShield />,
  title: "Warranty-safe work",
  body: "Servicing to manufacturer method keeps your door's integrity intact — backed by our own 1-Year Labour Warranty."
}];
export default function BrandsWhyExperts() {
  return <section id="brands-why" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .bw-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1.25rem; }
        .bw-facts { display: flex; gap: 2.5rem; flex-wrap: wrap; }
        @media (max-width: 880px) { .bw-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 520px) {
          .bw-grid { grid-template-columns: 1fr; }
          #brands-why { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-bw"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-bw)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "5rem",
      right: "2rem",
      width: "60px",
      height: "60px",
      borderTop: `2px solid ${GOLD}55`,
      borderRight: `2px solid ${GOLD}55`,
      pointerEvents: "none",
      zIndex: 1
    }} />

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        maxWidth: "620px",
        marginBottom: "3rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD_DARK,
          textTransform: "uppercase"
        }}>Why It Matters</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: NAVY,
          lineHeight: 1.15,
          margin: "0.75rem 0 0.75rem"
        }}>Why brand expertise actually matters</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.02rem",
          color: INK,
          lineHeight: 1.7
        }}>A garage door is a tensioned system under load. Knowing the brand isn't a nice-to-have — it's the difference between a fix that lasts and one that fails.</p>
        </div>

        <div className="bw-grid">
          {REASONS.map((r, i) => <div key={i} style={{
          background: "#fff",
          border: `1px solid ${GOLD}25`,
          borderRadius: "14px",
          padding: "1.75rem",
          boxShadow: "0 6px 22px rgba(8,20,56,0.05)"
        }}>
              <div style={{
            width: "50px",
            height: "50px",
            borderRadius: "12px",
            background: `${GOLD}1A`,
            border: `1px solid ${GOLD}33`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1.1rem"
          }}>{r.icon}</div>
              <h3 style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 800,
            fontSize: "1.05rem",
            color: NAVY,
            marginBottom: "0.5rem",
            lineHeight: 1.25
          }}>{r.title}</h3>
              <p style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.9rem",
            color: INK,
            lineHeight: 1.6
          }}>{r.body}</p>
            </div>)}
        </div>

        <div className="bw-facts" style={{
        borderTop: `1px solid ${GOLD}30`,
        paddingTop: "1.75rem",
        marginTop: "3rem"
      }}>
          {[{
          n: "12+",
          l: "Brands serviced"
        }, {
          n: "1st",
          l: "Visit fix rate, most jobs"
        }, {
          n: "1-Yr",
          l: "Labour warranty"
        }, {
          n: "5.0★",
          l: "Google rating"
        }].map((f, i) => <div key={i}>
              <div style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 800,
            fontSize: "1.75rem",
            color: NAVY,
            lineHeight: 1
          }}>{f.n}</div>
              <div style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.78rem",
            color: GOLD_DARK,
            marginTop: "0.25rem",
            fontWeight: 600
          }}>{f.l}</div>
            </div>)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}